const upsellProducts = document.querySelectorAll('.upsell-product');
const productsVariantId = document.querySelectorAll('.extra-product-input.extra-product');
const productsQuantity = document.querySelectorAll('.extra-product-qty.extra-product');

function selectHandler(select, index) {
  Array.from(select).forEach(option => {
    if (option.selected) {
      productsVariantId[index].setAttribute('value', option.value);
    }
  })
}

upsellProducts.forEach((product, index) => {
  const select = product.querySelector('select');
  product.addEventListener('click', () => {

    setTimeout(() => {
      if (product.classList.contains('checked')) {
        if (select) {
          selectHandler(select, index);
        }
        productsVariantId[index].removeAttribute('disabled');
        productsQuantity[index].removeAttribute('disabled');
      } else {
        productsVariantId[index].setAttribute('disabled', '');
        productsQuantity[index].setAttribute('disabled', '');
      }
    }, 0);
  })

  select && select.addEventListener('change', () => {
    selectHandler(select, index)

    if (product.classList.contains('see-popup')) {
      product.classList.remove('popup-check', 'select-check', 'see-popup', 'custom-checked', 'shake-anim');

      const label = product.querySelector('label');
      if (label) label.click();
    }
  })

  if (select && product.classList.contains('popup-check') && !product.classList.contains('see-popup')) {
    const selectWrapper = product.querySelector('.upsell-variant-selector-wrapper')
    selectWrapper.addEventListener('click', () => {
      if (!product.classList.contains('extra-see-popup')) {
        document.body.classList.add('show-check-popup-pdp');
        product.classList.add('see-popup', 'custom-checked');
        product.classList.add('extra-see-popup');
      }
    })
  }
});